import type { NodeProps } from '../types';

export type AnchorLinkTargetProps = NodeProps<{
  target: string;
}> & { nested?: boolean };

export function AnchorLinkTarget({ props }: AnchorLinkTargetProps) {
  return <span id={props.target} />;
}
